import api from "../api/axios";

// ← عدّل لو urls بتاعة quizzes متركّبة تحت prefix (مثلاً "/quiz-api")
const BASE = "quizzes";

const get = (url, params) => api.get(`${BASE}${url}`, { params }).then((r) => r.data);
const post = (url, body) => api.post(`${BASE}${url}`, body).then((r) => r.data);
const patch = (url, body) => api.patch(`${BASE}${url}`, body).then((r) => r.data);
const del = (url) => api.delete(`${BASE}${url}`).then((r) => r.data);

export const quizService = {
  list: (params) => get("/quizzes/", params),
  create: (data) => post("/quizzes/", data),
  update: (id, data) => patch(`/quizzes/${id}/`, data),
  remove: (id) => del(`/quizzes/${id}/`),
  duplicate: (id, groupIds) => post(`/quizzes/${id}/duplicate/`, { group_ids: groupIds }),
  listQuestions: (id) => get(`/quizzes/${id}/questions/`),
  addQuestions: (id, payload) => post(`/quizzes/${id}/questions/`, payload), // object أو array
  deleteQuestion: (id, questionId) => del(`/quizzes/${id}/questions/${questionId}/`),
  regeneratePassword: (id) => post(`/quizzes/${id}/regenerate-password/`),
  // ───────── استيراد الأسئلة من التطبيقات ─────────
  sourceApps: () => get("/quiz-sources/"),
  browseSource: (app, params) => get(`/quiz-sources/${app}/browse/`, params),
  sourceQuestions: (app, skillId, params) =>
    get(`/quiz-sources/${app}/skills/${skillId}/questions/`, params),
  importQuestions: (id, payload) => post(`/quizzes/${id}/questions/import/`, payload),
  resetStudent: (quizId, studentId) =>
  post(`/quizzes/${quizId}/students/${studentId}/reset/`),

  // ملخص اختبارات طلبة المجموعة (أو تفاصيل طالب معين لو params.student_id)
  groupQuizResults: (groupId, isAdmin, params) =>
    get(
      isAdmin
        ? `/admin/teacher-groups/${groupId}/quiz-results/`
        : `/teacher/groups/${groupId}/quiz-results/`,
      params
    ),
  getResults: (id) => get(`/quizzes/${id}/results/`),
};